import {combineReducers} from 'redux';

import usersReducers from './users';
import usersConfigReducers from './usersConfig';
import filesReducers from './files';
import panelReducers from './panel';
import masterDataReducers from './masterData';
import scheduleReducers from './schedule';
import reportsReducers from './reports';
import explorerReducers from './explorer';
import rhReducers from './rh';

export default combineReducers({
    users: usersReducers,
    files: filesReducers,
    panel: panelReducers,
    mdata: masterDataReducers,
    schedule: scheduleReducers,
    reports: reportsReducers,
    explorer: explorerReducers,
    rh: rhReducers,
    usersconfig: usersConfigReducers
});
